import { render } from "./Article-Preview.vue?vue&type=template&id=20e64a20&scoped=true"
import script from "./Article-Preview.vue?vue&type=script&lang=js"
export * from "./Article-Preview.vue?vue&type=script&lang=js"

import "./Article-Preview.vue?vue&type=style&index=0&id=20e64a20&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Asus\\Desktop\\vue\\akpa\\akpa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e64a20"]])

export default __exports__